// https://material-ui.com/customization/spacing/

export const spacing = 4;
export default {
  spacing: (factor) => `${spacing * factor}px`
};
